import { MaybeRefOrGetter, useArrayFindIndex } from '@vueuse/core';

export type LocaleRouteFunction = ReturnType<ReturnType<typeof useLocaleRoute>>;

export function useRouteSubSteps(steps: MaybeRefOrGetter<LocaleRouteFunction[]>) {
  const route = useRoute();

  const currentIndex = useArrayFindIndex(steps, (step) => step && step.path === route.path);
  const currentSubStep = computed(() => toValue(steps)[currentIndex.value]);
  const previousSubStep = computed(() => toValue(steps)[currentIndex.value - 1]);
  const nextSubStep = computed(() => toValue(steps)[currentIndex.value + 1]);

  async function setStep(step: NonNullable<LocaleRouteFunction>) {
    await navigateTo(step);
  }

  async function resetSubSteps() {
    const stepToGo = toValue(steps)[0];

    if (!stepToGo) return;

    await setStep(stepToGo);
  }

  async function goToNextSubStep() {
    if (!nextSubStep.value) return false;

    await setStep(nextSubStep.value);

    return true;
  }

  async function goToPreviousSubStep() {
    if (!previousSubStep.value) return false;

    await setStep(previousSubStep.value);

    return true;
  }

  return {
    goToNextSubStep,
    goToPreviousSubStep,
    resetSubSteps,
    currentSubStep,
    previousSubStep,
    nextSubStep,
  };
}
